import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { CDN_BASE_URL } from "../../config/cdn";

const logo = `${CDN_BASE_URL}/images/new_logo-removebg-preview.png`;

const Header = ({ theme = "light" }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();

    const handleNav = (e, path) => {
        e.preventDefault();
        navigate(path);
        setIsMenuOpen(false);
    };

    const whoWeServeMenu = [
        {
            title: "Ambulatory Services & Clinics",
            description: "Elevate your ambulatory and clinic performance with solutions engineered for outstanding care outcomes.",
            icon: `${CDN_BASE_URL}/icons/ambulatory-services---clinics-icon-for-this.jpg`,
            link: "/ambulatoryClinics",
        },
        {
            title: "Individual Providers & Group Practices",
            description: "Empower your practice with innovative tools that boost provider excellence and patient satisfaction.",
            icon: `${CDN_BASE_URL}/icons/individual-providers---group-practices-icon-for-th.jpg`,
            link: "/clinicians",
        },
        {
            title: "Practice Administrators",
            description: "Streamline operations and optimize revenue with RCM solutions crafted for administrative success.",
            icon: `${CDN_BASE_URL}/icons/practice-administrators-icon-for-this.jpg`,
            link: "/businessFinance",
        },
        {
            title: "Hospitals",
            description: "Drive hospital excellence with customizable, integrated solutions designed for complex care needs.",
            icon: `${CDN_BASE_URL}/icons/hospitalsicon-for-this.jpg`,
            link: "/hospitals",
        },
        {
            title: "Genomic Laboratories",
            description: "Streamline billing, reduce denials, and maximize reimbursements while maintaining full compliance.",
            icon: `${CDN_BASE_URL}/icons/diagnostic---pathology-laboratories-icon-for-this.jpg`,
            link: "/genomicLaboratories",
        },
    ];

    return (
        <header className={`header ${theme}`}>
            <nav className="navbar">
                <div className="navbar-container">
                    <div className="navbar-logo">
                        <a href="/" onClick={(e) => handleNav(e, "/")}>
                            <img src={logo} alt="MedRCM" className="logo-image" />
                        </a>
                    </div>

                    <div className={`navbar-menu ${isMenuOpen ? "active" : ""}`}>
                        <ul className="navbar-nav">
                            <li className="nav-item dropdown">
                                <button type="button" className="nav-link dropdown-trigger">
                                    Who We Serve
                                    <span className="dropdown-icon"></span>
                                </button>

                                <div className="dropdown-menu">
                                    <div className="dropdown-grid-five-cols">
                                        {whoWeServeMenu.map((item, index) => (
                                            <a
                                                key={index}
                                                href={item.link}
                                                className="dropdown-item-vertical"
                                                onClick={(e) => handleNav(e, item.link)}
                                            >
                                                <div className="item-icon-circle">
                                                    <img src={item.icon} alt={item.title} className="item-icon-img" />
                                                </div>
                                                <div className="item-text-content">
                                                    <h3 className="item-title-small">{item.title}</h3>
                                                    <p className="item-desc-small">{item.description}</p>
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </li>

                            <li className="nav-item">
                                <a href="/solutions" className="nav-link" onClick={(e) => handleNav(e, "/solutions")}>Solutions</a>
                            </li>
                            <li className="nav-item">
                                <a href="/AI-Solutions" className="nav-link" onClick={(e) => handleNav(e, "/AI-Solutions")}>AI-Solutions</a>
                            </li>
                            <li className="nav-item">
                                <a href="/aboutUS" className="nav-link" onClick={(e) => handleNav(e, "/aboutUS")}>About Us</a>
                            </li>
                        </ul>
                    </div>

                    <div className="navbar-actions">
                        <a
                            href="/contactUS"
                            className="contact-btn"
                            onClick={(e) => handleNav(e, "/contactUS")}
                        >
                            Contact
                        </a>
                        <button
                            className="menu-toggle"
                            onClick={() => setIsMenuOpen(!isMenuOpen)}
                            aria-label="Toggle menu"
                        >
                            <span></span><span></span><span></span>
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
